
export const Footer = () => {
  return (
    <footer className="bg-gray-900 mt-30 p-16">
        <div className="max-w-screen-xl mx-auto p-4">
            <p className="text-center text-gray-100 dark:text-gray-400 text-sm">Cart Demo. All rights reserved.</p>
        </div>
    </footer>
  )
}
